import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  newsContainer: {
    '& > div + div': {
      marginTop: 16,
    },
  },
}));
